export default "__VITE_ASSET__73d8d74a__"